import AiBotApiRulesAPI from 'dashboard/api/aiBot/apiRules';
import { throwErrorMessage } from '../../utils/api';

const types = {
  SET_UI_FLAG: 'SET_UI_FLAG',
  SET_RECORDS: 'SET_RECORDS',
  ADD_RECORD: 'ADD_RECORD',
  UPDATE_RECORD: 'UPDATE_RECORD',
  REMOVE_RECORD: 'REMOVE_RECORD',
};

export const state = {
  records: [],
  meta: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getRecords: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
  getMeta: $state => $state.meta,
};

export const actions = {
  get: async ({ commit }, { botId }) => {
    commit(types.SET_UI_FLAG, { isFetching: true });
    try {
      const response = await new AiBotApiRulesAPI(botId).get();
      commit(types.SET_RECORDS, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_UI_FLAG, { isFetching: false });
    }
  },

  create: async ({ commit }, { botId, ...rule }) => {
    commit(types.SET_UI_FLAG, { isCreating: true });
    try {
      const response = await new AiBotApiRulesAPI(botId).create(rule);
      commit(types.ADD_RECORD, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, { botId, id, ...rule }) => {
    commit(types.SET_UI_FLAG, { isUpdating: true });
    try {
      const response = await new AiBotApiRulesAPI(botId).update(id, rule);
      commit(types.UPDATE_RECORD, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async ({ commit }, { botId, id }) => {
    commit(types.SET_UI_FLAG, { isDeleting: true });
    try {
      await new AiBotApiRulesAPI(botId).delete(id);
      commit(types.REMOVE_RECORD, id);
      return id;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_UI_FLAG, { isDeleting: false });
    }
  },

  test: async (_context, { botId, id, message, variables }) => {
    try {
      const response = await new AiBotApiRulesAPI(botId).test(id, {
        message,
        variables,
      });
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    }
  },
};

export const mutations = {
  [types.SET_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.SET_RECORDS]($state, records) {
    $state.records = records;
  },
  [types.ADD_RECORD]($state, record) {
    $state.records = [record, ...$state.records];
  },
  [types.UPDATE_RECORD]($state, record) {
    $state.records = $state.records.map(item =>
      item.id === record.id ? record : item
    );
  },
  [types.REMOVE_RECORD]($state, id) {
    $state.records = $state.records.filter(item => item.id !== id);
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
